import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * Un componente de ruta que restringe el acceso basado en el rol del usuario.
 * @param {{ children: React.ReactNode, allowedRoles: string[] }} props
 */
const RoleBasedRoute = ({ children, allowedRoles }) => {
  const { userData, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!userData || !allowedRoles.includes(userData.role)) {
    // El usuario no tiene el rol permitido, redirigir a una ruta por defecto según su rol
    const defaultPath =
      userData?.role === 'derivador'        ? '/contact-requests' :
      userData?.role === 'Médico Veterinario' ? '/scheduler' :
      userData?.role === 'Director Médico'  ? '/scheduler' :
      userData?.role === 'Gerente Sucursal' ? '/' :
      userData?.role === 'Tecn\u00f3logo M\u00e9dico' ? '/lab' :
      userData?.role === 'Radiologo'        ? '/imaging' :
      userData?.role === 'gestion'          ? '/lab/orders' :
      '/';
    return <Navigate to={defaultPath} replace />;
  }

  return children;
};

export default RoleBasedRoute;
